module.exports = __webpack_public_path__ + "img/logo.b9c19650.png";